import { CustomField } from "@/backend/models/customFields/customField";
import { ObjectCustomField } from "@/backend/models/customFields/objectCustomField";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { Parameter } from "@/backend/models/parameter";
import { Form } from "react-bootstrap";
import { ObjectKeyVisibility } from "@/types/customFieldTypes";
import { ObjectListCard } from "../objectList/ObjectListCard";
import { CustomFieldInput } from "../customFIelds/CustomFieldInput";
import { ChoiceLabelAndValue } from "./ChoiceLabelAndValue";

export function MultipleChoiceParameterSelect(props: { parameter: Parameter, disabled?: boolean }) {
  const { parameter, disabled } = props;

  return (
      <>
        { parameter.fields.map(field => <Option key={field.id} field={field} parameter={parameter} disabled={disabled} /> )}
      </>
  );
}

function Option(props: { field: CustomField, parameter: Parameter, disabled?: boolean }) {
  const { field, parameter, disabled } = props;
  const updateCustomField = useParameterStore((state) => state.updateCustomField);

  const selectValue = (isSelected: boolean) => {
    void updateCustomField({ ...field, isSelected });
  };

  const label = field.getLabel();

  return (
    <div className='d-flex' key={field.id}>
      <Form.Check
        checked={field.isSelected}
        onChange={(val) => selectValue(val.target.checked)}
        aria-label={I18n.get('selectValue', { value: label })}
        disabled={disabled}
      />
      <OptionValue field={field} parameter={parameter} disabled={disabled} />
    </div>
  );
}

function OptionValue(props: { field: CustomField, parameter: Parameter, disabled?: boolean }) {
  const { field, parameter, disabled } = props;

  if (field instanceof ObjectCustomField) {
    if (field.objectInstance.properties.some(property => property.visibility === ObjectKeyVisibility.EDITABLE) || field.isCustomChoice) {
      return <div className='mt-1'>
        <ObjectListCard
          key={field.id}
          item={field as ObjectCustomField}
          parameter={parameter}
          runView
          disabled={disabled}
        />
      </div>;
    }
    return <span className='fusa-menu-item'>{field.objectInstance.title}</span>;
  }

  if (field.isCustomChoice) {
    return <CustomFieldInput customField={field} isEditView readOnly={disabled} />;
  }

  return <ChoiceLabelAndValue field={field} />;

}
